<angular-template tag="div">
    <ui-select
        class="sg-element vrm-select vrm-select--center"
        ng-class="{'sg-error': hasError}"
        theme="select2"
        ng-model="$parent.value"
        ng-disabled="disabled"
        search-enabled="searchEnabled"
        remove-selected="removeSelected"
    >
        <ui-select-match placeholder="{{placeholder}}">
            <div class="selected-option-container">
                <span class="vrm-icon vrm-icon-xsmall" style="display:inline-block" ng-class="$select.selected.iconClass"></span>
                <span class="selected-option">{{$select.selected.name}}</span>
            </div>
        </ui-select-match>
        <ui-select-choices repeat="option in options | filter:{name: $select.search}">
            <div class="flex-select">
                <span class="vrm-icon vrm-icon-xsmall" ng-class="option.iconClass"></span>
                <span data-cy="select-input-{{$index+1}}">{{option.name}}</span>
            </div>
        </ui-select-choices>
    </ui-select>
</angular-template>
<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';

@Component()
export default class VrmDropdown extends Vue {
    @Prop({ type: Array, default: () => [] })
    options;
    @Prop({ type: Boolean, default: false })
    searchEnabled;
    @Prop({ type: Boolean, default: false })
    removeSelected;
    @Prop({ type: Boolean, default: false })
    disabled;
    @Prop({ type: Boolean, default: false })
    hasError;
    @Prop({ type: String, default: null })
    placeholder;

    @Model('input', { default: null })
    value;
}
</script>
